import i18n from "../../../../../../i18n";
const { t } = i18n;
export const colum = [
  {
    label: t('smartReport.stt'),
    key: "stt",
    align: 'center',
    width: '5%'
  },
  {
    label: t('faceDetect.image'),
    key: "avatar",
    align: 'center',
  },
  {
    label: t('faceDetect.nameEmploy'),
    key: "name",
  },
  {
    label: t('faceDetect.nameDepart'),
    key: "department",
  },
  {
    label: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? t('faceDetect.company') : "",
    key: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? "organization_name" : '',
    align: 'left',
  },
  {
    label: t('faceDetect.timeAdd'),
    key: "time",
    align: 'center',
  },
];